// Utility function to open chat widget
// This function attempts to open Zendesk chat widget using $zopim API

// export const openChat = () => {
//   // Try Zendesk $zopim API (primary method - matches chat-script.js)
//   if (window.$zopim) {
//     try {
//       window.$zopim.livechat.window.toggle();
//       console.log("Zendesk chat opened via $zopim API");
//       return;
//     } catch (e) {
//       console.error("$zopim API error:", e);
//     }
//   }

//   // Try Zendesk zE API (fallback)
//   if (window.zE) {
//     try {
//       window.zE("messenger", "open");
//       console.log("Zendesk chat opened via messenger API");
//       return;
//     } catch (e) {
//       try {
//         window.zE("webWidget", "open");
//         console.log("Zendesk chat opened via webWidget API");
//         return;
//       } catch (err) {
//         console.error("Zendesk webWidget API error:", err);
//       }
//     }
//   }

//   // Fallback - show contact info if no chat widget is detected
//   console.warn("No chat widget detected. Showing contact information.");
//   alert("Chat is loading... If it doesn't appear, please contact us at:\nPhone: +1 (888) 655 0682\nEmail: info@bookcreationstudio.com");
// };

export const openChat = () => {
  // Chat functionality disabled
  // TODO: Add new chat integration here
  console.log("Chat is currently disabled");
};
